import type { Brand } from "@shared/brand.types";
import { brandDisplayName } from "@/lib/brand";

/**
 * L'école, en tête du panneau gauche, à la place qu'occupait le logo Mentor Goal.
 *
 * Le nom est en `h4` du référentiel, pas en petit gris : une entreprise doit voir
 * d'un coup d'œil à qui elle s'adresse. Le logo est à côté du nom, et non au-dessus
 * du titre : au-dessus, il ajoutait un troisième niveau de hiérarchie entre l'école
 * et l'intitulé de la page.
 */
export function SchoolMasthead({ brand }: { brand: Brand }) {
	const name = brandDisplayName(brand);

	return (
		<div className="flex items-center gap-3">
			{brand.logoUrl ? (
				<img
					src={brand.logoUrl}
					alt=""
					className="h-10 w-10 rounded-field border border-mg-border-subtle bg-mg-surface object-contain p-1"
				/>
			) : (
				<span className="t-h4 grid h-10 w-10 place-items-center rounded-field border border-mg-border-subtle bg-mg-subtle text-mg-heading">
					{name.slice(0, 1)}
				</span>
			)}
			<p className="t-h4 text-mg-heading">{name}</p>
		</div>
	);
}

/** Le titre de la page, sous l'identité de l'école. */
export function PageTitle({ title, intro }: { title: string; intro?: string | null }) {
	return (
		<div>
			<h1 className="t-h1 text-mg-heading">{title}</h1>
			{intro ? <p className="t-body-lg mt-3 text-mg-body">{intro}</p> : null}
		</div>
	);
}
